import { Placement } from '@floating-ui/react';

export type PopoverRef = {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
};

export const PopoverTrigger = {
  Click: 'click',
  Hover: 'hover',
  Focus: 'focus',
} as const;
export type PopoverTrigger = (typeof PopoverTrigger)[keyof typeof PopoverTrigger];

export type PopoverProps = {
  offset?: number;
  placement?: Placement;
  useAutoPlacement?: boolean;
  trigger?: PopoverTrigger;
  disabled?: boolean;
  onOpenChange?: (open: boolean) => void;
};
